import type { ReactNode } from "react";
import { Form } from "@circle-react-uikit/Form";
import type { ItemProps } from "@circle-react-uikit/Form/Item";

interface FormItemProps extends ItemProps {
  children?: ReactNode;
}

const FormItem = (props: FormItemProps) => (
  <Form.Item
    hideDescription
    hideBorder
    fullWidth
    translationRoot="support_widget_v2.send_message_form"
    {...props}
  />
);

export default FormItem;
